
if (!customElements.get('intersection-loader')) {
  class IntersectionLoader extends HTMLElement {
    constructor() {
      super();
      
      this.url = this.dataset.url;
      this.sectionId = this.dataset.sectionId || false;
      // used for Algolia product tiles
      this.objectId = this.dataset.objectId || false;
      this.position = this.dataset.position || false;
      this.dataExtra = this.dataset.extra?.split(',') || false;
    }
    
    connectedCallback() {
      if (!this.sectionId) return;
      const loader = document.querySelector(`template[data-loader="${this.sectionId}"]`)?.cloneNode(true);

      if (!this.hasChildNodes()) {
        if (loader) {
          this.innerHTML = loader.innerHTML;
        } else {
          this.classList.add('sp-aspect-[78/100]', 'sp-relative', 'sp-flex', 'sp-items-center', 'sp-justify-center', 'sp-loading');
          this.innerHTML = `
            <div class="loader">
              <span class="sp-block sp-w-12 sp-h-12">
                <svg class="sp-animate-spin -sp-ml-1 sp-mr-3 sp-h-full sp-w-full sp-text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              </span>
            </div>
          `;
        }
      }
      
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadFromAPI().then(() => this.observer.unobserve(this));
            }
          })
        },
        { rootMargin: '0px', threshold: 0.1 }
        );
        this.observer.observe(this);
      }
      
      async loadFromAPI() {
        const url = new URL(this.url, window.location.origin);
        const searchParams = new URLSearchParams(url.search);
        searchParams.set('section_id', this.sectionId);
        const urlToFetch = `${url.origin.toString()}${url.pathname.toString()}?${searchParams.toString()}`;
        
        fetch(urlToFetch)
          .then((response) => response.text())
          .then((text) => {
            const temp = document.createElement('div');
            const newNode = document.createElement('div');

            temp.innerHTML = text;
            newNode.innerHTML = temp?.querySelector(`#shopify-section-${this.sectionId}`)?.innerHTML ?? '';
            [...newNode.children].forEach(child => {
              if (this.objectId && this.position) {
                child.dataset.objectId = this.objectId;
                child.dataset.position = this.position;
              }
              if (this.dataExtra ) {
                this.dataExtra.forEach(extra => {
                  let dataPair = extra.split(':');
                  child.setAttribute(`data-${dataPair[0]}`, dataPair[1])
                })
              }
              this.before(child);
            });
            
            this.remove();
          });
        
      }
    }
    
    customElements.define('intersection-loader', IntersectionLoader);
  }